import { render, staticRenderFns } from "./MailIn.vue?vue&type=template&id=7a4ff0e1&"
import script from "./MailIn.vue?vue&type=script&lang=js&"
export * from "./MailIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports